import { render, staticRenderFns } from "./TherapyService.vue?vue&type=template&id=020a41d0&scoped=true"
import script from "./TherapyService.vue?vue&type=script&lang=js"
export * from "./TherapyService.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/component/radio-button.css?vue&type=style&index=0&id=020a41d0&prod&scoped=true&lang=css&external"
import style1 from "./TherapyService.vue?vue&type=style&index=1&id=020a41d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "020a41d0",
  null
  
)

export default component.exports